import classNames from 'classnames'
import { memo, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { v4 } from 'uuid'

import Icon from '@/components/Icon/Icon'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import { update } from '@/store/cardlists/actions/update'
import { DEFAULT_FILTER_VALUE, DEFAULT_FILTER_VALUE_MAP, FilterType, NAME_MAP } from '@/types/additionalFilters'
import useDirectories from '@/utils/useDirectories'

import styles from './AdditionalFiltersButton.module.scss'

type Props = {
  filters: FilterType[]
  setFilters: (filters: FilterType[]) => void
}

const AdditionalFiltersButton = ({ filters, setFilters }: Props) => {
  const [showDropdown, setShowDropdown] = useState(false) // Manually control dropdown visibility so we can hide the tooltip
  const [theme] = useTheme()
  const { dir } = useDirectories()

  const changeFilter = (filter: keyof typeof NAME_MAP, i: number) => {
    const newValues = DEFAULT_FILTER_VALUE_MAP[filter as keyof typeof DEFAULT_FILTER_VALUE_MAP] || DEFAULT_FILTER_VALUE
    const newFilters = [
      ...filters.slice(0, i),
      {
        focus: true,
        key: v4(),
        type: filter,
        values: newValues,
      },
      ...filters.slice(i + 1),
    ]
    setFilters(newFilters)

    // Certain filters should auto-submit
    if (filter === 'universesBeyond') update({ filters: newFilters })
  }

  const modes = [
    'cardName',
    'typeLine',
    'colors',
    'manaValue',
    'power',
    'toughness',
    'rarity',
    'universesBeyond',
    'sets',
    'tags',
    'price',
    'salt',
    'inclusion',
    'num_decks',
  ]
  if (dir === 'cards') modes.push('lift')
  else modes.push('synergy')

  return (
    <DropdownButton
      className='ml-2'
      onSelect={(e) => changeFilter(e as keyof typeof DEFAULT_FILTER_VALUE_MAP, filters.length + 1)}
      onToggle={(nextShow) => setShowDropdown(nextShow)}
      show={showDropdown}
      size='sm'
      title={<Icon icon='filter' />}
      variant={theme}
    >
      {modes.map((value) => (
        <Dropdown.Item
          className={classNames({
            [styles.bold]: filters.some((f) => f.type === value),
            [styles.ub]: value === 'universesBeyond',
          })}
          eventKey={value}
          key={value}
        >
          {NAME_MAP[value as keyof typeof NAME_MAP]}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}

export default memo(AdditionalFiltersButton)
